import DirectDebit from '../presentational/DirectDebit';
import DataCheck from 'components/shared/generic/dataCheck/presentational/DataCheck';
import useTranslate from 'lib/languages/useTranslate';
import SectionTitle from 'components/shared/generic/sectionTitle/presentational/SectionTitle';
import PageContainer from 'components/shared/generic/pageContainer/presentational/PageContainer';
import { useGetDirectDebitsQuery } from 'lib/services';

const DirectDebitContainer = () => {
    const translate = useTranslate('directDebits');
    const { data: directDebits = [], isFetching } = useGetDirectDebitsQuery();

    return (
        <PageContainer>
            <SectionTitle
                title={translate('titleText')}
                backRoute="/payments"
            />
            <DataCheck
                data={directDebits}
                isLoading={isFetching}
                noDataMessage={translate('noDataMessage')}
            >
                <DirectDebit data={directDebits} />
            </DataCheck>
        </PageContainer>
    );
};

export default DirectDebitContainer;
